import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CobMetaPipe } from '@lockton-apps/shared/ui/pipes';

import { PoliciesEffects } from './+state/policies.effects';
import * as fromPolicies from './+state/policies.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromPolicies.POLICIES_FEATURE_KEY,
      fromPolicies.policiesReducer
    ),
    EffectsModule.forFeature([PoliciesEffects]),
  ],
  providers: [CobMetaPipe],
})
export class SharedDataAccessPoliciesModule {}
